// extracted by mini-css-extract-plugin
export default {"statList":"StatsList_statList__3BRqj","item":"StatsList_item__7ynPD"};